export default __webpack_public_path__ + "static/media/Letrero partida finalizada recortado.59952b3a.png";